import {CareTeamSortBy, SortOrder} from "../domain";
import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "../../pagination";

export type CareTeamListAction =
    | { type: 'SET_SORT_BY'; sortBy: CareTeamSortBy }
    | { type: 'SET_FETCH_PRACTITIONER_LIST_DONE'; refetchFunc: () => void; }
    | { type: 'SET_SHOW_NEW_MODAL'; }
    | { type: 'SET_HIDE_NEW_MODAL'; }
    | RelayPaginationActionPayload;

export interface CareTeamListState {
    sortBy: CareTeamSortBy;
    showNewModal: boolean;
    pagination: RelayPaginationState;
    refetchListFunc: VoidFunction | null;
}

export function initState(): CareTeamListState {
    return {
        pagination: new RelayPaginationState('0', 8),
        showNewModal: false,
        refetchListFunc: null,
        sortBy: {
            column: "firstName",
            order: SortOrder.DESC
        }
    };
}


export function careTeamListReducer(
    state: CareTeamListState,
    action: CareTeamListAction
): CareTeamListState {
    switch (action.type) {
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy
            };
        case 'SET_FETCH_PRACTITIONER_LIST_DONE':
            return {
                ...state,
                refetchListFunc: action.refetchFunc
            };
        case 'SET_SHOW_NEW_MODAL':
            return {
                ...state,
                showNewModal: true
            };
        case 'SET_HIDE_NEW_MODAL':
            return {
                ...state,
                showNewModal: false
            };
        default:
            return state;
    }
}
